import { z } from 'zod';

import { zodTimeStamp } from '@/utils/zodUtils';

/**
 * Vehicle schema (used by permits)
 */
export const Vehicle = z.object({
  plate: z.string().optional(),
  plateState: z.string().optional(),
  make: z.string().optional(),
  model: z.string().optional(),
  color: z.string().optional(),
});

export const VehicleWithRequiredPlateFields = Vehicle.extend({
  plate: z.string().min(1, 'Plate is required'),
  plateState: z.string().min(1, 'Plate State is required'),
});

export type VehicleType = z.infer<typeof Vehicle>;
export type VehicleWithRequiredPlateFieldsType = z.infer<
  typeof VehicleWithRequiredPlateFields
>;

/**
 * Vehicle Make schema (from v2 API)
 */
export const VehicleMakeSchema = z.object({
  id: z.number(),
  name: z.string(),
  created_at: zodTimeStamp.optional(),
  updated_at: zodTimeStamp.optional(),
});

export type VehicleMake = z.infer<typeof VehicleMakeSchema>;

/**
 * Vehicle Model schema
 */
export const VehicleModelSchema = z.object({
  id: z.number(),
  make_id: z.number(),
  name: z.string(),
  created_at: zodTimeStamp.optional(),
  updated_at: zodTimeStamp.optional(),
});

export type VehicleModel = z.infer<typeof VehicleModelSchema>;

export const VehicleMakeWithModelsSchema = z.object({
  id: z.number(),
  name: z.string(),
  models: z.array(VehicleModelSchema),
  created_at: zodTimeStamp.optional(),
  updated_at: zodTimeStamp.optional(),
});

export type VehicleMakeWithModels = z.infer<typeof VehicleMakeWithModelsSchema>;

export const VehicleMakeListSchema = z.array(VehicleMakeSchema);
export const VehicleModelListSchema = z.array(VehicleModelSchema);
export const VehicleMakeWithModelsListSchema = z.array(
  VehicleMakeWithModelsSchema
);

export type VehicleMakeList = z.infer<typeof VehicleMakeListSchema>;
export type VehicleModelList = z.infer<typeof VehicleModelListSchema>;
export type VehicleMakeWithModelsList = z.infer<
  typeof VehicleMakeWithModelsListSchema
>;
